import type { LocationPlugin, UIRouter } from "@uirouter/core";
import { locationPluginFactory, trimHashVal, BrowserLocationConfig, BaseLocationServices } from "@uirouter/core";

/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
class SWHashLocationService extends BaseLocationServices {
    private router;
    constructor(router: UIRouter) {
        super(router, false);
        this.router = router;
        window.addEventListener("hashchange", this._listener, false);
    }

    _get() {
        return trimHashVal(this._location.hash);
    }

    _set(state: any, title: string, url: string, replace: boolean) {
        try {
            if (replace && this._history) {
                const _url = url.startsWith("/") ? `#${url}` : `#/${url}`;
                // @ts-ignore FIXME: strict migration - Argument of type 'null' is not assignable to parameter of type 'string' — History.replaceState 'unused' param is legacy and DOM lib typing forbids null
                (this._history as History).replaceState(null, null, _url);
                this.router.urlService.sync();
            } else {
                this._location.hash = url;
            }
        } catch (e) {
            // fallback
            this._location.hash = url;
        }
    }

    dispose(router: UIRouter) {
        super.dispose(router);
        window.removeEventListener("hashchange", this._listener);
    }
}

export const swHashLocationPlugin: (router: UIRouter) => LocationPlugin = locationPluginFactory(
    "vanilla.hashBangLocation",
    false,
    // @ts-ignore FIXME: strict migration - Argument of type 'typeof SWHashLocationService' is not assignable — @uirouter/core's factory expects optional router but our subclass requires it; runtime always provides one
    SWHashLocationService,
    BrowserLocationConfig,
);
